export { checkForCollectStep } from "@budibase/shared-core/src/sdk/documents/automations"
